import Vue from 'vue'

import lightboxStore from './LightboxStore'
import store from "./../store/store.js";

Vue.directive('lightbox', {
  bind (el, binding) {
    el.addEventListener('click', function (e) {
      console.log("directive " + el.getAttribute('href'))
      e.preventDefault();
      e.stopImmediatePropagation();
      lightboxStore.state.href = el.getAttribute('href')
      lightboxStore.state.visible = true;
      store.state.is_gallery_lightbox = true;
      if(getFileExtension(lightboxStore.state.href) == "mp4"){
        lightboxStore.state.isVideo = true;
      }
      else {
        lightboxStore.state.isVideo = false;
      }
      function getFileExtension(filename) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
      }

    })
  }
})
